import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';
import { ARBEITSZEIT_UPDATE } from './graphql/mutation';
import {
  ArbeitszeitUpdateMutation,
  ArbeitszeitUpdateMutationVariables,
} from '../../../gql/graphql';

export function useArbeitszeitUpdate() {
  const [execute, result] = useMutation<
    ArbeitszeitUpdateMutation,
    ArbeitszeitUpdateMutationVariables
  >(ARBEITSZEIT_UPDATE, {
    refetchQueries: [
      'getArbeitszeitenByDateAndStandortId',
      'getArbeitszeitById',
      'GetToDos',
    ],
    awaitRefetchQueries: true,
  });

  const arbeitszeitTerminUpdate = useCallback(
    (variables: ArbeitszeitUpdateMutationVariables) => {
      return execute({
        variables,
      });
    },
    [execute],
  );

  return [arbeitszeitTerminUpdate, result] as const;
}
